// @flow
import React from 'react';

import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer';
import { TourInformation } from 'Components/widgets/tour-information/TourInformation';
import { type TourPracticalInformationDescriptorProps } from 'Client/cms/toolkit/tour-practical-information/tourPracticalInformation.resolver';

type TourPracticalInformationLineProps = {
  ...$Exact<TourPracticalInformationDescriptorProps>,
  resort: {
    practicalInformation: {
      healthFormalities: string,
      passportAndVisas: string,
      includedInPackage: Array<string>,
      excludedInPackage: Array<string>,
    },
  },
};

export const TourPracticalInformationLine = (props: TourPracticalInformationLineProps) => {
  const {
    resort: {
      practicalInformation: {
        includedInPackage,
        excludedInPackage,
        healthFormalities,
        passportAndVisas,
      },
    },
    immigrationFormalities,
    healthFormalities: healthFormalitiesTitle,
    includedInTour,
    notIncludedInTour,
  } = props;
  const infos = [];
  if (includedInPackage && includedInPackage.length) {
    infos.push({ title: includedInTour, items: includedInPackage });
  }
  if (excludedInPackage && excludedInPackage.length) {
    infos.push({ title: notIncludedInTour, items: excludedInPackage });
  }
  if (passportAndVisas) {
    infos.push({ title: immigrationFormalities, text: passportAndVisas });
  }
  if (healthFormalities) {
    infos.push({ title: healthFormalitiesTitle, text: healthFormalities });
  }
  if (!infos.length) {
    return null;
  }

  return (
    <SiteContainer className="Line">
      <TourInformation infos={infos} />
    </SiteContainer>
  );
};
